module.exports = __webpack_public_path__ + "img/browser-white.46460ce6.svg";